<div class="monitoring-tickets-osm-map">
  <div #mapContainer class="monitoring-tickets-osm-map__container"></div>

  <div class="monitoring-tickets-osm-map__state" *ngIf="loading">
    <app-loader></app-loader>
  </div>

  <div class="monitoring-tickets-osm-map__state monitoring-tickets-osm-map__state--error" *ngIf="errorText">
    {{ errorText }}
  </div>
</div>
